/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaTransfer = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        playerIn: {
            type: 'FantaPlayer',
            isRequired: true,
        },
        playerOut: {
            type: 'FantaPlayer',
            isRequired: true,
        },
        position: {
            type: 'PlayerPosition',
            isRequired: true,
        },
    },
} as const;
